import antd_fields from '@/locales/en-US/antd_fields';
import Guid from '@/services/Guid';
import { Select as AntSelect, Col, Form } from 'antd';
import { Option as IOption } from 'rc-select';
import type { IField } from '../data';

const { Item } = Form;
const { Option }: { Option: typeof IOption } = AntSelect;

const Select: React.FC<IField> = (props) => {
    const {
        name,
        span = 8,
        label,
        rules,
        hidden,
        placeholder,
        disabled,
        options,
        onChange,
        mode = undefined,
        allowClear = false,
        showSearch = false,
        onSearch,
        showArrow = true,
        notFoundContent = null,
        defaultActiveFirstOption = false,
        filterOption = false,
        defaultValue,
        suffix = false,
        suffixWidth,
        xs,
        lg,
        size,
        marginBottom = 0,
        value = null,
        tooltip,
        suffixIcon,
        dropdownRender,
        onDropdownVisibleChange,
        open,
        className,
        t,
    } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: {
            marginBottom: marginBottom ? marginBottom : undefined,
            paddingBottom: 0,
        },
    };

    const getProps = () => {
        if (value) return { value };
        return {};
    };

    return (
        <Col key={name} {...grid}>
            <Item tooltip={tooltip} required={rules?.at(0)?.required} hidden={hidden && hidden} label={t?.(label)} {...styling}>
                <Item noStyle name={name} rules={rules}>
                    <AntSelect
                        {...getProps()}
                        size={size}
                        onSearch={onSearch}
                        showSearch={showSearch}
                        mode={mode}
                        allowClear={allowClear}
                        onChange={onChange}
                        placeholder={t?.(placeholder)}
                        disabled={disabled}
                        open={open}
                        optionFilterProp="children"
                        filterOption={filterOption}
                        showArrow={suffix ? false : showArrow}
                        defaultActiveFirstOption={defaultActiveFirstOption}
                        notFoundContent={notFoundContent}
                        defaultValue={defaultValue}
                        dropdownRender={dropdownRender}
                        onDropdownVisibleChange={onDropdownVisibleChange}
                        style={suffix ? { width: `calc(100% - ${suffixWidth}px)` } : {}}
                        suffixIcon={suffixIcon}
                        className={className}
                        getPopupContainer={(trigger: HTMLElement) => {
                            return trigger.parentElement || trigger;
                        }}
                    >
                        {options?.map((option: any, index: number) => {
                            //Check if value exist on es-locales
                            const value = antd_fields[option.value] ? t?.(option.value) : option.value;
                            return (
                                <Option value={option.key} key={typeof option.key === 'boolean' ? Guid.create() : option.key + index}>
                                    {value}
                                </Option>
                            );
                        })}
                    </AntSelect>
                </Item>
                {suffix && suffix}
            </Item>
        </Col>
    );
};

export default Select;
